import { render } from "./ModalReceiveInvoiceSupplier.vue?vue&type=template&id=8f7e96ec&scoped=true"
import script from "./ModalReceiveInvoiceSupplier.vue?vue&type=script&lang=js"
export * from "./ModalReceiveInvoiceSupplier.vue?vue&type=script&lang=js"

import "./ModalReceiveInvoiceSupplier.vue?vue&type=style&index=0&id=8f7e96ec&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f7e96ec"]])

export default __exports__